import { INavElementsNode } from './nav-elements-nodegroup';

export class NavElementsRoot {

   constructor(
      public rootObj: INavElementsNode
   ) { }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/model/nav-elements-root.ts